/**
 * Access Token 仅存内存，刷新页面即清空；与 HttpOnly Refresh Cookie 配合实现双 Token。
 * 切勿写入 localStorage / sessionStorage。
 */
let accessToken = null

export function getAccessToken() {
  return accessToken
}

export function setAccessToken(token) {
  accessToken = token != null && String(token).trim() !== '' ? String(token).trim() : null
}

export function clearAccessToken() {
  accessToken = null
}

export function hasAccessToken() {
  return !!accessToken
}
